module.exports = __webpack_public_path__ + "static/media/remove.22c3d759.svg";